import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_2 = { class: "table" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["disabled", "onUpdate:modelValue", "aria-labelledby"]
const _hoisted_5 = ["disabled", "id", "name", "value", "onUpdate:modelValue"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 1,
  class: "h-10-em d-flex align-items-center justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.hidden && _ctx.statementInfo !== _ctx.loadingPlaceholder)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('review.upload.statements.realm')), 1),
              _createElementVNode("th", {
                id: _ctx.$id('commentHeading')
              }, _toDisplayString(_ctx.$t('general.comment')), 9, _hoisted_3),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.result')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statementInfo.realms, (realm, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: realm.id
              }, [
                _createElementVNode("td", null, _toDisplayString(realm.code) + " " + _toDisplayString(_ctx.$s(realm.name)), 1),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    disabled: this.disabled,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.value[index].comment) = $event),
                    "aria-labelledby": _ctx.$id('commentHeading'),
                    class: "form-control"
                  }, "\n            ", 8, _hoisted_4), [
                    [_vModelText, _ctx.value[index].comment]
                  ])
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statementInfo.resultOptions, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check",
                      key: option.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        disabled: this.disabled,
                        class: "form-check-input",
                        id: _ctx.$id('option-' + realm.id + '-' + option.id),
                        name: _ctx.$id('option-' + realm.id),
                        value: option.id,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.value[index].reviewCycleResultOptionId) = $event)
                      }, null, 8, _hoisted_5), [
                        [_vModelRadio, _ctx.value[index].reviewCycleResultOptionId]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: _ctx.$id('option-' + realm.id + '-' + option.id)
                      }, _toDisplayString(_ctx.$s(option.name)), 9, _hoisted_6)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    : (_ctx.statementInfo === _ctx.loadingPlaceholder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
}